import type { AnyForm } from './shared';
import type { ts } from '@funkey/shared';
import { Button } from '~/components/primitives';

export const SubmitButton: React.FC<
    ts.Object.override<
        Button.Props,
        {
            form: AnyForm;
            formID?: string;
            /** @default "Submit" */
            children?: React.ReactNode;
            type?: never;
        }
    >
> = ({ form, formID, ...props }) => (
    <form.Subscribe selector={state => [state.isValid, state.canSubmit, state.isSubmitting]}>
        {([isValid, canSubmit, isSubmitting]) => (
            <Button
                {...props}
                form={formID}
                type="submit"
                disabled={!isValid || !canSubmit || isSubmitting || props.disabled}
                isLoading={isSubmitting}
            >
                {props.children === undefined ? 'Submit' : props.children}
            </Button>
        )}
    </form.Subscribe>
);
